var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mini-chart"
  }, [_c('div', {
    staticClass: "chart-content",
    style: {
      height: 46
    }
  }, [_c('v-chart', {
    attrs: {
      "force-fit": true,
      "height": _vm.height,
      "data": _vm.data,
      "padding": [36, 5, 18, 5]
    }
  }, [_c('v-tooltip'), _c('v-smooth-area', {
    attrs: {
      "position": "x*y"
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };